<template lang="pug">
div
  .h-vertical-align-container(v-if="modalShow")
      .modal__close(@click='overlay()')
      .modal__overlay(@click='overlay()')
      .videoModal__wrapper
        .fluid__video#fluid__video--tutorial(v-html='ytVideo') {{ytVideo}}

  section.full__video
    .intro__content.intro__content--mobile.intro__content--homepage
      h1 Create Imagery That Gets Noticed
      h2 Magical tools for visual storytelling that stands out
      .btn__group.btn__group--homepage
        a(href='https://itunes.apple.com/ca/app/cinemagraph-pro/id642139481?mt=8')
          button.btn.btn--purpleLight Download free trial
          get-plan(
            copy='30% Off Yearly Plans'		
          )
    .fluid__video
      .intro__content.intro__content--desktop.intro__content--homepage
        h1 Create Imagery That Gets Noticed
        h2 Magical tools for visual storytelling that stands out
        .btn__group.btn__group--homepage
          download-trial-button(
            product='pro',
            classes='btn btn--purpleLight',
            copy='Download free trial')
          get-plan
      iframe(data-src='https://media.flixel.com/cinemagraph/nxy20rfgefrz1prdyamy?hd=true' allow='autoplay')
      .credit
        a(target='_blank' href='https://flixel.com/sherifmokbel/') Sherif Mokbel

  brands

  section
    .product__section#products
      .product__section--container
        .product__section--content
          .productItem__title
            img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/mac/icons/cinemagraph-pro-icon@2x.png 2x, https://cdn.flixel.com/static/static-web/products/mac/icons/cinemagraph-pro-icon.png 1x')
            h2
              | Cinemagraph Pro
              span for macOS
          .productItem__desc
            p Creating professional quality cinemagraphs is fast, fun and easy with Cinemagraph Pro for macOS. Winner of a 2014 Apple Design Award and the world’s favorite way to create cinemagraphs.
            .btn__group
              download-trial-button(
                product='pro',
                classes='btn btn--purpleLight',
                copy='Download free trial')
              a(href='/products/mac/cinemagraph-pro/')
                button.btn.btn--white Learn More
          img.lazy#designaward(data-srcset='https://cdn.flixel.com/static/static-web/awards/awardada@2x.png 2x ,https://cdn.flixel.com/static/static-web/awards/awardada.png 1x')
        .product__section--cinemagraph.cpCinemagraph
          .fluid__video
            iframe(data-src='https://media.flixel.com/cinemagraph/0ryeqmkxv7xgqxdwdgt2?hd=false')
  section.product__section--ios
    .product__section.product__section--ios
      .product__section--container.product__section--reverse
        .product__section--content
          .productItem__title
            img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/ios/icons/cinemagraph-pro-ios-icon@2x.png 2x,https://cdn.flixel.com/static/static-web/products/ios/icons/cinemagraph-pro-ios-icon.png 1x')
            h2
              | Cinemagraph Pro
              span for iOS
          .productItem__desc
            p Enjoy the magic of Cinemagraph Pro on the go. Capture, edit and create professional quality cinemagraphs easily with your iPhone or iPad. 
            .btn__group
              a.btn.btn--black(href='https://itunes.apple.com/ca/app/cinemagraph-pro/id642139481?mt=8') Download free trial
              a(href="/products/ios/cinemagraph-pro/")
                button.btn.btn--white Learn More
        .product__section--image
          img.lazy#iosImage(data-srcset='https://cdn.flixel.com/static/static-web/products/ios/cinemagraph-pro-ios@2x.png 2x, https://cdn.flixel.com/static/static-web/products/ios/cinemagraph-pro-ios.png 1x')
  section
    .product__section#products
      .product__section--container
        .product__section--content
          .productItem__title
            img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/blendeo/BlendeoAppIcon@2x.png 2x,https://cdn.flixel.com/static/static-web/products/blendeo/BlendeoAppIcon.png@1x 1x')
            h2
              | Blendeo
              span for iOS
          .productItem__desc
            p The hardest part of creating amazing long exposure photos and videos is out of the control of even the best photographers. With Blendeo you don’t need to get lucky, you control time.
            .btn__group
              .btn__group
                a.btn.btn--black(href='http://apple.co/Blendeo') Download free trial
                a(href="/products/ios/blendeo/")
                  button.btn.btn--white Learn More
        .product__section--image
          img.lazy.blendeo(data-srcset='https://cdn.flixel.com/static/static-web/products/blendeo/blendeo@2x.png 2x, https://cdn.flixel.com/static/static-web/products/blendeo/blendeo@1x.png 1x')

  section.flixelPlan__section
    .flixelPlan__container
      h1 Choose a plan that’s right for you
      p Whether you’re a photographer, marketer, or designer, creating cinemagraphs is fun, fast, and easy with Cinemagraph Pro. Select a plan and start using the best cinemagraph creation tools and web-sharing platform.
      .btn__group
        get-plan
  section
    .product__section
      .product__section--video
        a(href='https://www.youtube.com/watch?v=NDDcZvqHoQU' @click='ytModal($event)')
          img.lazy(data-src='https://cdn.flixel.com/static/static-web/home/flixel-video-tour.png')
          .playbtn

  section.callout__section.full__video--callout
    .fluid__video--callout.callout
      .callout__section--content
        .callout__section--text
          h2 Learn how top brands like Pepsi, Mercedes and Microsoft use cinemagraphs to get better results from their marketing programs.
          p
            a(href="/case-studies/") View Case Studies >
      iframe(data-src='https://media.flixel.com/cinemagraph/t8fuopy85aef55jsmzso?hd=true' allow='autoplay')

  section.callout__section--textmobile
    h2 Learn how top brands like Pepsi, Mercedes and Microsoft use cinemagraphs to get better results from their marketing programs.
    p
      a(href="/case-studies/") View Case Studies >

  section
    .product__section
      .product__section--container
        .product__section--content
          .productItem__title
            img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/persecond/icons/persecond-icon@2x.png 2x, https://cdn.flixel.com/static/static-web/products/persecond/icons/persecond-icon.png 1x')
            h2
              | Persecond
              span for macOS
          .productItem__desc
            p Speeding up life just got easier. Persecond for macOS transforms your image sets into mesmerizing time lapse videos.
            .btn__group
              download-trial-button(
                product='persecond',
                classes='btn btn--blue',
                copy='Download free trial')
              a(href="/products/mac/persecond")
                button.btn.btn--white Learn More
        .product__section--image
          img.lazy.fcpImage(data-srcset='https://cdn.flixel.com/static/static-web/products/persecond/persecondproduct@2x.png 2x, https://cdn.flixel.com/static/static-web/products/persecond/persecondproduct.png 1x')

  section
    .product__section
      .product__section--container.product__section--reverse
        .product__section--content#content--screensaver
          .productItem__title
            h2
              | Flixel Screensaver
              span for macOS
          .productItem__desc
            p Cinemagraphs from the Flixel community selected just for you. See a stunning new cinemagraph as your screensaver daily with the official Flixel Screensaver for macOS.
            .btn__group
              download-trial-button(
                product='screensaver',
                classes='btn btn--white',
                copy='Download for free')
        .product__section--image
          img.lazy#screenSaverImg(data-srcset='https://cdn.flixel.com/static/static-web/products/screensaver/flixel-screensaver@2x.png 2x, https://cdn.flixel.com/static/static-web/products/screensaver/flixel-screensaver.png 1x')

  section
    .product__section
      .product__section--container
        .product__section--content
          .productItem__title
            img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/products/flixel-tv/icons/tvos-icon@2x.png 2x, https://cdn.flixel.com/static/static-web/products/flixel-tv/icons/tvos-icon.png 1x')
            h2
              | Flixel TV
              span for tvOS
          .productItem__desc
            p The best way to display cinemagraphs on TVs. Experience your cinemagraphs, along with the work of thousands of other Flixel Artists, tutorials and fun behind-the-scenes content using our Apple TV app, all from the comfort of your couch.
            .btn__group
              a.btn.btn--purple(href='https://itunes.apple.com/ca/app/flixel-tv/id1043381618?mt=8')
                | Download for free
        .product__section--image#flixeltv
          img.lazy.fcpImage(data-srcset='https://cdn.flixel.com/static/static-web/products/flixel-tv/flixel-tv@2x.png 2x, https://cdn.flixel.com/static/static-web/products/flixel-tv/flixel-tv.png 1x')

  section.callout__section.full__video--callout
    .fluid__video--callout.callout
      .callout__section--content
        .callout__section--text
          h2 Work with the award-winning Flixel Studios team on custom campaigns, experientials and more.
          p
            a(href="/studios/") Learn more >
      .video__overlay--shadow
      iframe(data-src='https://media.flixel.com/cinemagraph/ruk9xhg8bustt1k6wa8f?hd=true' allow='autoplay')

  section.callout__section--textmobile
    h2 Work with the award-winning Flixel Studios team on custom campaigns, experientials and more.
    p
      a(href="/studios/") Learn more >

</template>

<script>
import Brands from 'components/Brands.vue';
import getPlan from 'components/getPlan.vue';
import downloadTrial from 'components/downloadTrial.vue';
import downloadTrialButton from 'components/downloadTrialButton.vue';

export default {
  name: 'Home',
  data() {
    return {
      modalShow: false,
      ytVideo: '',
      modalProduct: false,
    };
  },
  mounted() {
    const myLazyLoad = new LazyLoad({
      elements_selector: 'iframe, .lazy',
    });
    window.addEventListener('resize', function () {
      const iosImage = document.getElementById('iosImage');
      const rotation = (window.innerWidth) / 50;
      if (window.innerWidth > 768 && window.innerWidth < 1024) {
        iosImage.style.transform = 'rotate(' + rotation + 'deg)';
      } else {
        iosImage.style.transform = 'rotate(0deg)';
      }
    });
  },
  methods: {
    ytModal($event) {
      $event.preventDefault();
      const ytURL = $event.currentTarget.getAttribute('href');
      const iframeURL = ytURL.split('v=')[1];
      const videoHeight = window.innerHeight - 200;
      const videoWidth = window.innerWidth - 200;

      this.modalShow = true;
      $('body').bind('touchmove', function (e) {
        e.preventDefault();
      });
      this.ytVideo = '<iframe height=' + videoHeight + ' width= ' + videoWidth + ' src="https://www.youtube.com/embed/' + iframeURL + '?rel=0&amp;autoplay=1" frameborder="0" allowfullscreen></iframe>';
    },
    overlay() {
      $('body').unbind('touchmove');
      this.modalShow = false;
      this.modalProduct = false;
    },
  },
  components: {
    'Brands': Brands,
    'getPlan': getPlan,
    'downloadTrial': downloadTrial,
    'downloadTrialButton': downloadTrialButton,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Home.vue